import { useEffect, useState } from "react";
import { filterConstants } from "../../constants";

import {  transactionStatus, transactionType } from "../../enums";
import { useQueryString } from "../../hooks";
import {
  ITransaction,
  IQueryStringNavLinks,
  ITableHeader,
} from "../../interfaces-and-types";
import {  balancesData } from "../../test-data";
import { View } from "./View";

export interface IPaymentViewProps {
  data: ITransaction[];
  headers: ITableHeader[];
  isLoading: boolean;
  totalCount: number;
  queryStringTabs: IQueryStringNavLinks;

  // modals
  isCreateNewModalOpen: boolean;
  closeModal: () => void;

  // extra buttons
  onExport: () => void;
  onCreateNew: () => void;
}

export const TopUps = () => {
  const [isCreateNewModalOpen, setCreateNewModalOpen] = useState(false);
  const closeModal = () => {
    setCreateNewModalOpen(false);
  };

  const [isLoading, setisLoading] = useState(true);

  const query = useQueryString();
  const status = query.get(filterConstants.statusKey);

  useEffect(() => {
    setTimeout(() => setisLoading(false), 500);
  }, []);

  const headers: ITableHeader[] = [
    {
      key: "amount",
      header: "Amount",
    },
    {
      key: "status",
      header: "Status",
    },
    {
      key: "description",
      header: "Description",
    },
    {
      key: "date_initiated",
      header: "Date Initiated",
    },
    {
      key: "estimated_arrival",
      header: "Estimated Arrival",
    },
    
  ];

  const queryStringTabs: IQueryStringNavLinks = {
    query: filterConstants.statusKey,
    options: [
      {
        key: "Top-Ups",
        value: "top-ups",
      },
      
    ],
  };

  const queryFilteredData = balancesData
    .filter((tx) => tx.transactionType === transactionType.topUp)
    .filter(
      (tx) =>
        !status || status === "all" || transactionStatus[tx.status] === status
    );
  

  const onExport = () => {
    // export data via api and download
    alert("exporting data...");
  };
  const onCreateNew = () => {
    // openModal
    setCreateNewModalOpen(true);
  };

  return (
    <View
      data={queryFilteredData}
      headers={headers}
      isLoading={isLoading}
      totalCount={queryFilteredData.length}
      queryStringTabs={queryStringTabs}
      onExport={onExport}
      onCreateNew={onCreateNew}
      isCreateNewModalOpen={isCreateNewModalOpen}
      closeModal={closeModal}
    />
  );
};
